import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from './components/Cart';  // Import from Cart.js
import Navbar from './components/Navbar';
import Home from './components/Home';
import Footer from './components/Footer';
import Register from './components/Register';
import Login from './components/Login';
import FAQ from './components/FAQ';
import ContactUs from './components/ContactUs';
import AboutUs from './components/AboutUs';
import ProductDetails from './components/ProductDetails';
import Destination from './components/Destinations';
import Tours from './components/Tours';
import Blogs from './components/Blogs';
import Offer from './components/WhatWeOffer';
import DestinationInfo from './components/Destination_info';
import TourPackages from './components/TourPackage';
import AdminDestination from './components/admin/AdminDestination';
import AdminTour from './components/admin/AdminTour';
import AdminMenu from './components/admin/AdminMenu';
import PageNotFound from './components/PageNotFound';
import UserDashboard from './components/client/UserDashboard';
import TourEdit from './components/admin/TourEdit';
import DestinationEdit from './components/admin/DestinationEdit';
import UserEdit from './components/admin/UserEdit';
import BookedTickets from './components/client/BookedTickets';
import PaymentResponsePage from './components/PaymentResponsePage';
import CheckoutResponsePage from './components/CheckoutResponsePage';
import Receipts from './components/admin/Receipts';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import Shop from './components/ProductGrid';
import Hire from './components/CarHire';
import Cart from './components/Cart';
import AdminCarHire from './components/admin/AdminCarHire';
import CarHireEdit from './components/admin/CareHireEdit';
import AdminProducts from './components/admin/AdminProducts';
import Checkout from './components/Checkout';
import AdminPickup from './components/admin/AdminLocation';
import Shipping from './components/client/ShippingAddressForm'
import OrderHistory from './components/client/OrderHistory';
import AdminOrders from './components/admin/AdminOrders';
import BlogPost from './components/BlogPost'
import AdminBlog from './components/admin/AdminBlog'
import EditBlog from './components/admin/BlogsEdit'
import RequestQuote from './components/RequestQuote';

// Import the new PayPal checkout component
import PaypalReceipt from "./components/PayPalReceipt";

function App() {
  return (
    <div className="App">
      <CartProvider>  
        <BrowserRouter>
          <Navbar/>   
          <Routes>
            <Route index element={<Home/>}></Route>
            <Route exact path='/home' element={<Home/>}></Route>
            <Route exact path='/register' element={<Register/>}></Route>
            <Route exact path='/what-we-offer' element={<Offer/>}></Route>
            <Route exact path='/login' element={<Login/>}></Route>
            <Route exact path='/faq' element={<FAQ/>}></Route>
            <Route exact path='/contact-us' element={<ContactUs/>}></Route>
            <Route exact path='/about-us' element={<AboutUs/>}></Route>
            <Route exact path='/destinations' element={<Destination/>}></Route>
            <Route exact path='/tours' element={<Tours/>}></Route>
            <Route exact path='/blogs' element={<Blogs/>}></Route>
            <Route exact path='/tour-packages' element={<TourPackages/>}></Route>
            <Route path="/destination-info" element={<DestinationInfo />}></Route>         
            <Route exact path='/admin-destination' element={<AdminDestination/>}></Route>
            <Route exact path='/admin-tour' element={<AdminTour/>}></Route>
            <Route exact path='/dashboard-admin' element={<AdminMenu/>}></Route>
            <Route exact path='/error404' element={<PageNotFound/>}></Route>
            <Route exact path='/dashboard-user' element={<UserDashboard/>}></Route>
            <Route exact path='/tour-edit' element={<TourEdit/>}></Route>
            <Route exact path='/destination-edit' element={<DestinationEdit/>}></Route>
            <Route exact path='/user-edit' element={<UserEdit/>}></Route>
            <Route exact path='/BookedTickets' element={<BookedTickets/>}></Route>
            <Route exact path='/response-page' element={<PaymentResponsePage/>}></Route>
            <Route exact path='/checkout-response-page' element={<CheckoutResponsePage/>}></Route>
            <Route exact path='/booked-receipts' element={<Receipts/>}></Route>
            <Route exact path='/forgot-password' element={<ForgotPassword/>}></Route>
            <Route exact path='/reset-password/:token' element={<ResetPassword/>}></Route>
            <Route exact path='/shop' element={<Shop/>}></Route>
            <Route exact path='/car-hire' element={<Hire/>}></Route>
            <Route exact path='/admin-carhire' element={<AdminCarHire/>}></Route>
            <Route exact path='/carhire-edit' element={<CarHireEdit/>}></Route>
            <Route exact path='/admin-products' element={<AdminProducts/>}></Route>
            <Route exact path='/cart' element={<Cart/>}></Route>
            <Route exact path='/product-details' element={<ProductDetails/>}></Route>
            <Route exact path="/checkout" element={<Checkout />}> </Route>
            <Route exact path="/admin-pickup-point" element={<AdminPickup />}> </Route>
            <Route exact path="/shipping-info" element={<Shipping />}> </Route>
            <Route exact path="/admin-orders" element={<AdminOrders />}> </Route>
            <Route exact path="/order-history" element={<OrderHistory />}> </Route>
            <Route exact path="/blog-post" element={<BlogPost />}> </Route>
            <Route exact path="/admin-blog" element={<AdminBlog />}> </Route>
            <Route exact path="/blog-edit" element={<EditBlog />}> </Route>

            <Route exact path="/request-quote" element={<RequestQuote />} />

            {/* PayPal Checkout Route – Unique path */}
 <Route path="/paypal/success" element={<PaypalReceipt />} />

          </Routes>
          <Footer/>
        </BrowserRouter>
      </CartProvider>
    </div>
  );
}

export default App;